import { SxProps } from '@mui/material';

export const savedAddressContainerSX: SxProps = {
	display: 'flex',
	flexDirection: 'column',
	gap: '10px',
};

export const addAddressMsgSX: SxProps = {
	color: 'grey.500',
};

export const addAddressBtnSX: SxProps = {
	height: 41.56,
};

export const savedAddressOptionsContainerSX: SxProps = {
	display: 'flex',
	flexDirection: 'column',
	gap: '10px',
};

export const addAddressTriggerSX: SxProps = {
	display: 'flex',
	alignItems: 'center',
	color: 'secondary.main',
	'&:hover': {
		cursor: 'pointer',
		textDecoration: 'underline',
	},
	gap: '5px',
};

export const addAddressTriggerIconSX: SxProps = {
	color: 'primary.main',
};

export const savedAddressDividerSX: SxProps = {
	my: '10px',
	'&:last-child': {
		display: 'none',
	},
};
